import { render } from "./ClientMenuTab.vue?vue&type=template&id=a5a16034&scoped=true"
import script from "./ClientMenuTab.vue?vue&type=script&lang=js"
export * from "./ClientMenuTab.vue?vue&type=script&lang=js"

import "./ClientMenuTab.vue?vue&type=style&index=0&id=a5a16034&lang=stylus&scoped=true"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a16034"]])

export default __exports__